import { render } from "./AudienceCompaniesView.vue?vue&type=template&id=203ee33a"
import script from "./AudienceCompaniesView.vue?vue&type=script&lang=js"
export * from "./AudienceCompaniesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__